import React from 'react';
import SEO from '../../components/SEO';
import SectionLayout from '../../layouts/SectionLayout';
import locationsImg from '../../images/locations-with-callouts.png';
import caiLogo from '../../images/cai-stacked-no-text.png';
import './index.scss';

export default function About() {
  return (
    <div className="about-section">
      <SEO title="About us" />
      <SectionLayout>
        <div style={{ width: '75px', margin: '0 auto' }}>
          <img className="img-fluid" alt="CultivateAI logo" src={caiLogo} />
        </div>
        <div id="our-company" className="mb-5">
          <h4
            className="section-display-subheader"
            style={{ marginTop: '0.5rem' }}
          >
            Our Company
          </h4>
          <div className="mobile-desktop-text-margin row">
            <div className="col-sm-12">
              <p>
                In September 2024, CultivateAI was acquired by Verity, a
                subsidiary of Gevo. Verity provides transparency,
                accountability, and efficiency in tracking, measuring, and
                verifying various attributes throughout the supply chain.
                Together, CultivateAI and Verity are unlocking new possibilities
                in agricultural data management, aligning technology with
                sustainability and operational excellence.
              </p>
              <p>
                {`We understand that collecting data is easy, but turning it into
                actionable insights can be challenging. That's why our
                passionate team of agricultural software developers and service
                providers built a cloud-based system that takes the work out of
                Ag data management. Our tools empower you to make intelligent,
                informed, and strategic decisions with ease.`}
              </p>
              <p>
                {`With over 15 years of success in Precision Ag data, GIS, and
                site-specific crop management software for diverse agricultural
                operations—including our own family farms—we know how complex
                data management can be. We're here to simplify it. Now, with the
                backing of Verity and Gevo, we are more equipped than ever to
                provide innovative solutions that combine drone and satellite
                imaging with advanced analytics. This allows you to observe,
                manage, and respond to crop variability with unprecedented
                accuracy—helping you grow more, do more, and use fewer resources
                along the way. Together, we're cultivating a smarter, more
                sustainable future for agriculture.`}
              </p>
            </div>
          </div>
        </div>
        <div id="locations" className="mb-5">
          <h4 className="section-display-subheader">Locations</h4>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <img
              alt="map of locations"
              className="img-fluid"
              src={locationsImg}
            />
          </div>
        </div>
        {/* <div className="text-center" id="contact">
          <h4
            className="section-display-subheader"
            style={{ marginBottom: '0.5rem' }}
          >
            <Link to="/about#contact">Contact us!</Link>
          </h4>
          <iframe
            title="about contact form"
            src="https://app.hellobonsai.com/f/f77a77b9b1f79e1?embed=true"
            frameBorder="0"
            width="100%"
            height="100%"
            style={{
              border: 'none',
              minHeight: '1500px',
            }}
          />
        </div> */}
      </SectionLayout>
    </div>
  );
}
